import { ProjectContext } from "@/context/project.context";
import { useCallback, useContext, useEffect } from "react";
import HeaderDetail from "./HeaderDetail";
import HeaderProjectInfo from "./HeaderProjectInfo";
import ProjectMobileTab from "./ProjectMobileTab";
import ModalViewDetailFile from "@/modules/Mobile/ProjectDetailMobile/RightContent/ModalViewDetailFile";
import { checkFollowProject } from "@/api/endpoint/project/check-follow-project";
import { useAuth } from "@/hooks/useAuth";

const ProjectDetailMobile = () => {
  const {
    project,
    checkFollowProject: dataFollowProject,
    setCheckFollowProject,
    selectedViewFiles,
  } = useContext(ProjectContext);

  const { token } = useAuth();
  const handleCheckFollowProject = useCallback(async () => {
    const res = await checkFollowProject({ project: project?._id }, token);
    if (res?.results) {
      setCheckFollowProject(true);
    } else {
      setCheckFollowProject(false);
    }
  }, [project?._id, setCheckFollowProject, token]);
  useEffect(() => {
    if (token) {
      handleCheckFollowProject();
    }
  }, [handleCheckFollowProject, token]);
  return (
    <div className="wrap-home bg-grey-50 min-h-screen flex flex-col">
      <HeaderDetail />

      <HeaderProjectInfo
        project={project}
        isFollowProject={dataFollowProject}
      />
      <ProjectMobileTab />
      {selectedViewFiles?.currentFile ? <ModalViewDetailFile /> : null}
    </div>
  );
};

export default ProjectDetailMobile;
